import { z } from 'zod'

const baseCapacitySchema = z
  .number({
    message: '기준케파를 입력해 주세요.',
  })
  .min(1, { message: '케파는 1 이상 입력해 주세요.' })
  .max(99999999, { message: '최대 99,999,999까지 입력할 수 있어요.' })

export const capacityDayFormSchema = z.object({
  b2cBaseCapacity: baseCapacitySchema,
  isUnlimited: z.boolean(),
})

export type CapacityDayFormSchema = z.infer<typeof capacityDayFormSchema>
